import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function Login() {
  const navigate = useNavigate();

  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  function handleChange(e) {
    setForm({ ...form, [e.target.name]: e.target.value });
  }

  async function handleLogin() {
    setLoading(true);
    setError("");

    try {
      const res = await fetch(
        "https://digital-worker-exchange.onrender.com/api/auth/login",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(form),
        }
      );

      const data = await res.json();

      if (!res.ok) {
        setError(data.message || "Login failed");
        setLoading(false);
        return;
      }

      /* ✅ STORE EVERYTHING PROPERLY */
      const role = data.user.role.toLowerCase();

      localStorage.setItem("token", data.token);
localStorage.setItem("role", role);
localStorage.setItem("userId", data.user.id);

localStorage.setItem(
  "name",
  data.user.name || data.user.fullName || "User"
);

localStorage.setItem(
  "user",
  JSON.stringify(data.user)
);

      /* ✅ REDIRECT */
      if (role === "worker") {
  navigate("/worker/dashboard");
} else {
  navigate("/employer/dashboard");
}

    } catch (err) {
      setError("Server error. Try again.");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 via-white to-emerald-50 px-4">

      <div className="w-full max-w-md bg-white/80 backdrop-blur-xl border border-white/30 shadow-2xl rounded-3xl p-8">

        {/* HEADER */}
        <h1 className="text-3xl font-extrabold text-gray-900 text-center">
          Welcome Back
        </h1>

        <p className="text-center text-gray-500 mt-2">
          Login to continue to your dashboard
        </p>

        {/* ERROR */}
        {error && (
          <div className="mt-4 p-3 rounded-xl bg-red-100 text-red-600 text-sm text-center">
            {error}
          </div>
        )}

        {/* INPUTS */}
        <div className="mt-6 space-y-4">
          <input
            name="email"
            type="email"
            placeholder="Enter your email"
            className="w-full p-3 rounded-xl border border-gray-300 focus:ring-2 focus:ring-blue-400 outline-none"
            value={form.email}
            onChange={handleChange}
          />

          <input
            name="password"
            type="password"
            placeholder="Enter your password"
            className="w-full p-3 rounded-xl border border-gray-300 focus:ring-2 focus:ring-blue-400 outline-none"
            value={form.password}
            onChange={handleChange}
          />
        </div>

        {/* BUTTON */}
        <button
          onClick={handleLogin}
          disabled={loading}
          className={`mt-6 w-full py-3 rounded-xl font-semibold text-white transition
            ${
              loading
                ? "bg-gray-400 cursor-not-allowed"
                : "bg-gradient-to-r from-blue-600 to-emerald-500 hover:opacity-90 shadow-lg"
            }`}
        >
          {loading ? "Logging in..." : "Login"}
        </button>

        {/* FOOTER */}
        <p className="text-center text-gray-600 mt-5 text-sm">
          Don’t have an account?{" "}
          <span
            onClick={() => navigate("/signup")}
            className="text-blue-600 font-semibold cursor-pointer hover:underline"
          >
            Sign Up
          </span>
        </p>

      </div>
    </div>
  );
}